'use strict';

var config = [

    {

        route: '/most-innovative-companies/:year/sectors/:sector',

        method: ['GET'],

        controller: 'renderSector',

        view: {
            route: 'most-innovative-companies/:year/sectors/:sector',
            alias: 'sector',
            file: 'js/sector.js'
        },

        timeout: 2000

    },
    {

        route: '/most-innovative-companies/:year/sectors',

        method: ['GET'],

        controller: 'renderSector',

        view: {
            route: 'most-innovative-companies/:year/sectors',
            alias: 'sector-index',
            file: 'js/sector.js'
        },

        timeout: 2000

    }

];

exports.config = config;

